import { CodeHighlightAdapterProvider, createShikiAdapter } from '@mantine/code-highlight'

export default function LocalCodeHighlightAdapterProvider({
  children,
}: {
  children: React.ReactNode
}) {
  async function loadShiki() {
    const { createHighlighter } = await import('shiki')
    const shiki = await createHighlighter({
      langs: ['toml', 'json'],
      themes: [],
    })

    return shiki
  }

  const shikiAdapter = createShikiAdapter(loadShiki)

  return (
    <CodeHighlightAdapterProvider adapter={shikiAdapter}>{children}</CodeHighlightAdapterProvider>
  )
}
